import css from 'styled-jsx/css';

export default css`
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
    flex-direction: column;
  }
  .section {
    margin-top: 0;
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 60px;
    background-color: #131313;
    padding: 35px 60px 35px 60px;
    border-radius: 3px;
  }
  .title {
    font-size: 32px;
    font-family: 'Eurostile-Bold';
    margin-bottom: 0;
    margin-top: 0;
    width: 100%;
    text-align: center;
  }
  .paragraph {
    margin-bottom: 0;
    margin-top: 4%;
    white-space: break-spaces;
  }
  .paragraph-section-desktop {
    display: flex;
    flex-direction: column;
  }
  .paragraph-section-mobile {
    display: none;
  }
  @media (max-width: 600px) {
    .paragraph-section-mobile {
      display: inherit;
    }
    .paragraph-section-desktop {
      display: none;
    }
    .section {
      width: 85%;
      padding: 25px 35px 25px 35px;
    }
    .paragraph {
      margin-top: 15%;
      text-align: center;
      line-height: 25px;
      font-size: 12px;
    }
    .main-container {
      margin-top: 8%;
    }
  }
`;